import { render, staticRenderFns } from "./SecretPasswordBody.vue?vue&type=template&id=66de1902&"
import script from "./SecretPasswordBody.vue?vue&type=script&lang=ts&"
export * from "./SecretPasswordBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports